module.exports = __webpack_public_path__ + "static/media/noresults.f98e4692.svg";